import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringReplacement',
  standalone: true,
})
export class StringReplacementPipe implements PipeTransform {
  transform(value: string, args: Record<string, string> = null): string {
    if (
      !value ||
      !args ||
      typeof value !== 'string' ||
      typeof args !== 'object'
    ) {
      return value;
    }
    let result = value;

    for (const key in args) {
      if (Object.hasOwn(args, key)) {
        // replace all
        result = result.replaceAll(new RegExp(key, 'g'), args[key]);
      }
    }

    return result;
  }
}
